
<div class="pg-index">
  <div class="section1">
    <div class="logo"></div>
    <div class="slogan"></div>
    <div class="sub-title"></div>
  </div>
  <div class="section2">
    <!-- 无id且未登陆或未创建队伍 -->
    <div class="btn create"></div>
  </div>
  <div class="section3">
    <div class="op">
      <div class="op-btn rule" @click="showRule"></div>
      <div class="op-btn content" @click="showPrize"></div>
    </div>
    <a :href="address" class="guanzhu" target="_blank"></a>
  </div>
</div>
